<div class="search--input">
    <input class="mvd_form-control autocomplete" id="search" type="text"
        placeholder="{{placeholder}}" autocomplete="off" [(ngModel)]="searchString"
        (ngModelChange)="searchStringChanged($event)" (keyup.enter)="search()"/>
    <button class="search__icon" title="Search" type="button" (click)="search()"></button>
</div>